<template>
  <async-btn
    v-if="isGranted('TRASH_POST')"
    :task="task"
    icon="fa fa-trash-alt"
    title="Trash"
    :class="cssClass"
    v-bind="$attrs"
    @click="trashOrConfirm"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Post } from '@/type';
import AsyncBtn from '@/components/AsyncBtn.vue';
import openModal from '@/components/modal';
import notify from '@/components/notify';
import gtm from '@/tracking/gtm';
import isGranted from '@/auth/isGranted';
import { trash, restore, isUnreviewed } from '../post';
import TrashPostModal from './TrashPostModal.vue';

interface Data {
  task: Promise<Post>|null,
}

export default defineComponent({
  emits: ['restored', 'trashed'],
  components: { AsyncBtn },
  props: {
    post: {
      type: Object as () => Post,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  computed: {
    requiresConfirmation(): boolean {
      return !isUnreviewed(this.post.status);
    },
    cssClass(): string {
      return this.requiresConfirmation ? '' : gtm.TRASH_POST;
    },
  },
  methods: {
    trash() {
      const vm = this;
      this.task = trash(this.post.id);
      this.task.then((post: Post) => {
        this.$emit('trashed', post);
        notify({
          message: 'Post trashed.',
          timeout: 10000,
          actions: [
            {
              label: 'Undo',
              handler() {
                vm.undo(post.id);
              },
            },
          ],
        });
      });
    },
    confirm() {
      const props = { post: this.post, parent: this };
      openModal(TrashPostModal, props).onOk(() => {
        this.trash();
      });
    },
    trashOrConfirm() {
      if (this.requiresConfirmation) {
        this.confirm();
      } else {
        this.trash();
      }
    },
    undo(postId: number) {
      this.task = restore(postId);
      this.task.then((post: Post) => {
        this.$emit('restored', post);
        notify('Post restored.');
      });
    },
    isGranted,
  },
});
</script>
